import React from "react";
import { useTranslation } from "react-i18next";
import { PiPlantFill } from "react-icons/pi";
import { ReactComponent as Icon } from "../../icons/work-experience/idea.svg";
import "./workexperience.css";

export default function Learning({ id }) {
  const { t } = useTranslation();
  const learning = t(`experience.${id}.learning`, {
    returnObjects: true,
  });

  return (
    <div className="content-container">
      <h2 className="we-card-title">{t("experience.learning")}</h2>
      <div className="bullet-list">
        {learning.map(({ text }) => (
          <span key={text}>
            <PiPlantFill />
            <p>{text}</p>
          </span>
        ))}
      </div>
      <div className="we-bg-icon">
        <Icon />
      </div>
    </div>
  );
}
